export default "__VITE_ASSET__DgIiWZOA__"